import { render, staticRenderFns } from "./EscalaAbrir.vue?vue&type=template&id=ea506a20&"
import script from "./EscalaAbrir.vue?vue&type=script&lang=js&"
export * from "./EscalaAbrir.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports